import React, { useState, useMemo, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Tooltip,
  Modal,
  Form,
  Input,
  TimePicker,
  Button,
  message,
  Alert,
} from "antd";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import {
  DeleteOutlined,
  ClockCircleOutlined,
  FileProtectOutlined,
  ProfileOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import "dayjs/locale/fr";
import { useTranslation } from "react-i18next";
dayjs.locale("fr");




export default function GestionCalendrierExamens({form,modules,setModules, title,dateDebut, dateFin, type,scheduled,setScheduled}) {
  // const [scheduled, setScheduled] = useState({});
    const { t } = useTranslation();
  const [modalInfo, setModalInfo] = useState({ visible: false, module: null, date: null });
  const [startHour, setStartHour] = useState(null);
 const MIN_HOUR = 8;
 const MAX_HOUR = 18;

 const startDate = dayjs(dateDebut, "DD/MM/YYYY");
 const endDate = dayjs(dateFin, "DD/MM/YYYY");
  const diff = endDate.diff(startDate, "day") + 1;
  const dates = Array.from({ length: diff }, (_, i) => startDate.add(i, "day"));

  const onDragEnd = (result) => {
    if (!result.destination) return;
    const { draggableId, destination } = result;
    const module = modules.find((m) => m.id === draggableId);
    if (!module) return;
    setModalInfo({ visible: true, module, date: destination.droppableId });
    console.log("dd",modalInfo)
  };

  const handleAddModule = () => {
  form.validateFields(["start", "end", "room"]).then(({ start, end, room }) => {
    const newStart = dayjs(start);
    const newEnd = dayjs(end);

    if (newEnd.isSame(newStart) || newEnd.isBefore(newStart)) {
      message.error("L'heure de fin doit être après l'heure de début.");
      return;
    }

    const dateKey = modalInfo.date;
    const newStartStr = newStart.format("HH:mm");
    const newEndStr = newEnd.format("HH:mm");

    const conflict = (scheduled[dateKey] || []).find((m) => {
      const existingStart = dayjs(m.start, "HH:mm");
      const existingEnd = dayjs(m.end, "HH:mm");

      return (
        // Cas 1 : chevauchement début ou fin
        (newStart.isBefore(existingEnd) && newEnd.isAfter(existingStart))
      );
    });

    if (conflict) {
      // message.error(`Conflit avec le module "${conflict.name}" de ${conflict.start} à ${conflict.end}.`);
       message.error(t("Un autre module est déjà planifié durant cette période. Veuillez choisir une autre date."));
      return;
    }

    // Aucun conflit : ajout du module
    setScheduled((prev) => ({
      ...prev,
      [dateKey]: [
        ...(prev[dateKey] || []),
        { ...modalInfo.module, start: newStartStr, end: newEndStr, room },
      ],
    }));

    setModules((prev) => prev.filter((m) => m.id !== modalInfo.module.id));
    setModalInfo({ visible: false, module: null, date: null });
    setStartHour(null);
    
    // Réinitialisation des champs start, end et room
    form.setFieldsValue({ start: null, end: null, room: null });
  });
};

// const handleAddModule = () => {
//   form.validateFields(["start", "end", "room"]).then(({ start, end, room }) => {
//     const newStart = dayjs(start);
//     const newEnd = dayjs(end);

//     if (newEnd.isSame(newStart) || newEnd.isBefore(newStart)) {
//       message.error("L'heure de fin doit être après l'heure de début.");
//       return;
//     }

//     const dateKey = modalInfo.date;
//     const newStartStr = newStart.format("HH:mm");
//     const newEndStr = newEnd.format("HH:mm");

//     const conflict = (scheduled[dateKey] || []).find((m) => {
//       const existingStart = dayjs(m.start, "HH:mm");
//       const existingEnd = dayjs(m.end, "HH:mm");

//       return (
//         // Cas 1 : chevauchement début ou fin
//         (newStart.isBefore(existingEnd) && newEnd.isAfter(existingStart))
//       );
//     });

//     if (conflict) {
//       message.error(`Conflit avec le module "${conflict.name}" de ${conflict.start} à ${conflict.end}.`);
//       return;
//     }

//     // Aucun conflit : ajout du module
//     setScheduled((prev) => ({
//       ...prev,
//       [dateKey]: [
//         ...(prev[dateKey] || []),
//         { ...modalInfo.module, start: newStartStr, end: newEndStr, room },
//       ],
//     }));

//     setModules((prev) => prev.filter((m) => m.id !== modalInfo.module.id));
//     setModalInfo({ visible: false, module: null, date: null });
//     setStartHour(null);
//     form.resetFields();
//   });
// };

  useEffect(() => {
  console.log("modules",modules)
  console.log("/***schee",scheduled)
  }, [modules,scheduled])
  

  const handleDelete = (dateKey, id) => {
    setScheduled((prev) => {
      const copy = { ...prev };
      const mod = copy[dateKey].find((m) => m.id === id);
      copy[dateKey] = copy[dateKey].filter((m) => m.id !== id);
      if (!copy[dateKey].length) delete copy[dateKey];
      setModules((prev) => [...prev, { id: mod.id, name: mod.name,seuil: mod?.seuil, unite_seuil: mod?.unite_seuil}]);
      return copy;
    });
  };


  


  
  const disabledHours = () => {
    const hours = [];
    for (let i = 0; i < 24; i++) {
      if (i < MIN_HOUR || i > MAX_HOUR) {
        hours.push(i);
      }
    }
    return hours;
  };
  
  useEffect(() => {
   console.log("mo",modules,type)

  }, [])
  
  
  return (
    <>
    

      <div style={{ padding: 20 }}>
    
        <Alert
          type="info"
          style={{ marginBlock: "1rem" }}
          message="                 "
          description="cc"
          showIcon
        />
        <DragDropContext onDragEnd={onDragEnd}>
          <Row gutter={16}>
            <Col span={16}>
              <Card title= {title}>
                {dates.map((date) => {
                  const key = date.format("DD/MM/YYYY");
                  const label = date.format("dddd DD/MM/YYYY").replace(/^./, (c) => c.toUpperCase());
                  return (
                    <Droppable key={key} droppableId={key}>
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                          style={{ marginBottom: 16, padding: 12, border: "1px solid #ccc", borderRadius: 8, background: "#fafafa" }}
                        >
                          <strong>{label}</strong>
                          <div style={{ display: "flex", flexWrap: "wrap", marginTop: 8 }}>
                            {(scheduled[key] || []).map((mod) => (
                              <Tooltip key={mod.id} title={mod.name}>
                                <Card
  size="small"
  style={{
    width: 200,
    margin: 8,
    background: "#f0f9ff",
    border: "1px solid #69c0ff",
    borderRadius: 12,
    position: "relative",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
    transition: "all 0.3s ease",
  }}
  hoverable
>
  <DeleteOutlined
    onClick={() => handleDelete(key, mod.id)}
    style={{
      position: "absolute",
      top: 10,
      right: 10,
      color: "red",
      fontSize: 16,
      cursor: "pointer",
      display: "flex", alignItems: "center",
    }}
  />

  <div >
    <ProfileOutlined style={{ marginRight: 8, color: "#195A99", fontSize: 16 }} />
    <strong style={{ fontSize: 16, color: "#003a8c" }}> {mod.id} </strong>
  </div>

   <div >
    <FileProtectOutlined style={{ marginRight: 8, color: "#195A99",marginBlock:8 }} />
    <span style={{ fontSize: 14 }}>Seuil : {mod?.seuil} {mod?.unite_seuil}</span>
  </div>

  <div >
    <ClockCircleOutlined style={{ marginRight: 8, color: "#195A99" }} />
    <span style={{ fontSize: 14 }}>Durée : {mod.start} - {mod.end}</span>
  </div>

  <div >
    <FileProtectOutlined style={{ marginRight: 8, color: "#195A99",marginBlock:8 }} />
    <span style={{ fontSize: 14 }}>Salle : {mod.room}</span>
  </div>
</Card>

</Tooltip>
                            ))}
                          </div>
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  );
                })}
              </Card>
            </Col>

            <Col span={8}>
              <Card title="Modules à planifier">
                <Droppable droppableId="modules">
                  {(provided) => (
                    <div ref={provided.innerRef} {...provided.droppableProps}>
                      {modules?.map((mod, idx) => (
                        <Draggable key={mod.id} draggableId={mod.id} index={idx}>
                          {(p) => (
                            <Tooltip title={mod.name}>
                              <div
                                ref={p.innerRef}
                                {...p.draggableProps}
                                {...p.dragHandleProps}
                                style={{ padding: 8, margin: "8px 0", background: "#f0f0f0", borderRadius: 8, textAlign: "center", ...p.draggableProps.style }}
                              >
                              {mod.id}{` (Seuil :${mod?.seuil} ${mod?.unite_seuil})`}
                              </div>
                            </Tooltip>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </Card>
            </Col>
          </Row>
        </DragDropContext>

        <Modal
          title={`Planifier ${modalInfo.module?.name}`}
          visible={modalInfo.visible}
          onCancel={() => {
            setModalInfo({ visible: false, module: null, date: null });
            setStartHour(null);
             form.setFieldsValue({ start: null, end: null, room: null });
            // form.resetFields();
          }}
          onOk={handleAddModule}
          okText="Ajouter"
          cancelText="Annuler"
        >
          <Form form={form} layout="vertical">
            <Form.Item label="Heure de début" name="start" rules={[{ required: true }]}>  
              <TimePicker
                style={{ width: "100%" }}
                format="HH:mm"
                minuteStep={15}
                disabledHours={disabledHours}
                hideDisabledOptions={true} 
                showNow={false}
                onChange={(v) => setStartHour(v)}
              />
            </Form.Item>
            <Form.Item label="Heure de fin" name="end" rules={[{ required: true }]}>  
              <TimePicker
                style={{ width: "100%" }}
                format="HH:mm"
                minuteStep={15}
                disabledHours={disabledHours}
                hideDisabledOptions={true} 
                showNow={false}
                disabled={!startHour}
              />
            </Form.Item>
            <Form.Item label="Salle" name="room" rules={[{ required: true } ,{
                  validator: (_, value) => {
                    if (value && value.trim() === "") {
                      return Promise.reject(t("Veuillez remplir ce champ."));
                    }
                    return Promise.resolve();
                  },
                },]}>  
              <Input />
            </Form.Item>
          </Form>
        </Modal>

     
      </div>
    </>
  );
}
